export const media_ru = {
    gallery: "Галерея",
    photo: "Фото"
}